import {useState} from 'react';

import {useGetFaqUrlQuery} from 'presentation/pages/private/help/queries/useGetFaqUrlQuery';
import {useGetWomenChannelUrlQuery} from 'presentation/pages/private/help/queries/useGetWomenChannelUrlQuery';

export function useHelpExternalLinks() {
	const [isFaqIframeOpen, setIsFaqIframeOpen] = useState(false);
	const [isExternalLinkError, setIsExternalLinkError] = useState(false);

	const {data: faqData, refetch: getFaqData, isLoading: isFaqLoading} = useGetFaqUrlQuery();
	const {refetch: getWomenChannelData, isLoading: isWomenChannelLoading} =
		useGetWomenChannelUrlQuery();

	const handleOpenFaq = async () => {
		const {data, isError} = await getFaqData();
		if (isError) {
			setIsExternalLinkError(true);
			return;
		}
		if (data?.url) {
			setIsFaqIframeOpen(true);
		}
	};

	const handleOpenWomenChannel = async () => {
		const {data, isError} = await getWomenChannelData();
		if (isError) {
			setIsExternalLinkError(true);
			return;
		}
		if (data?.url) {
			window.open(data.url, '_blank', 'noopener noreferrer');
		}
	};

	const handleCloseFaqIframe = () => {
		setIsFaqIframeOpen(false);
	};

	const handleCloseExternalLinkError = () => {
		setIsExternalLinkError(false);
	};

	return {
		faqUrl: faqData?.url ?? '',
		isFaqLoading,
		isWomenChannelLoading,
		isFaqIframeOpen,
		isExternalLinkError,
		handleOpenFaq,
		handleOpenWomenChannel,
		handleCloseFaqIframe,
		handleCloseExternalLinkError,
	};
}
